// extracted by mini-css-extract-plugin
export default {"wrapper":"ChargingStationManagement_wrapper__jvak0"};